import { render, staticRenderFns } from "./dialogNewServiceAvailability.vue?vue&type=template&id=1634f872"
import script from "./dialogNewServiceAvailability.vue?vue&type=script&lang=ts"
export * from "./dialogNewServiceAvailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports